/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathPi = createReactComponent("outline", "math-pi", "IconMathPi", [["path", { "d": "M7 20v-16", "key": "svg-0" }], ["path", { "d": "M17 4v16", "key": "svg-1" }], ["path", { "d": "M20 4h-16", "key": "svg-2" }]]);

export { IconMathPi as default };
//# sourceMappingURL=IconMathPi.mjs.map
